/**
 * runtimeEvents.js — Event type constants + factory.
 *
 * All Kevia runtime events share the same schema. Callers
 * provide only the fields relevant to their event type.
 *
 * NOTE: Keep the schema flat for easy serialization — future
 * backend transport and semantic memory indexing will expect
 * a consistent shape across event types.
 */

/* ─── Event type registry ─────────────────────────────────────────────── */

export const RT_EVENTS = Object.freeze({
  // Entity / navigation
  OPEN_ENTITY:         "OPEN_ENTITY",
  OPEN_MODULE:         "OPEN_MODULE",
  NAVIGATE:            "NAVIGATE",

  // Record mutations
  CREATE_RECORD:       "CREATE_RECORD",
  EDIT_RECORD:         "EDIT_RECORD",
  DELETE_RECORD:       "DELETE_RECORD",

  // Conversation cognition
  START_CONVERSATION:  "START_CONVERSATION",
  SEND_MESSAGE:        "SEND_MESSAGE",
  RETRY_RESPONSE:      "RETRY_RESPONSE",

  // UI interaction
  EXECUTE_ACTION_CHIP: "EXECUTE_ACTION_CHIP",
  OPEN_HISTORY:        "OPEN_HISTORY",
  SEARCH_HISTORY:      "SEARCH_HISTORY",

  // FASE 19 — Cognitive persistence
  RUNTIME_RESTORED:    "RUNTIME_RESTORED",

  // FASE 22 — Workflow lifecycle
  WORKFLOW_STARTED:    "WORKFLOW_STARTED",
  WORKFLOW_UPDATED:    "WORKFLOW_UPDATED",
  WORKFLOW_COMPLETED:  "WORKFLOW_COMPLETED",
  WORKFLOW_PAUSED:     "WORKFLOW_PAUSED",
});

/* ─── Event factory ───────────────────────────────────────────────────── */

let _seq = 0;

/**
 * Creates a typed runtime event with a stable, compact schema.
 *
 * @param {{
 *   type:        string,
 *   route?:      string,
 *   module?:     string,
 *   entityType?: string,
 *   entityId?:   string,
 *   entityName?: string,
 *   metadata?:   object,
 * }} fields
 * @returns {RuntimeEvent}
 */
export function createRuntimeEvent({
  type,
  route      = null,
  module     = null,
  entityType = null,
  entityId   = null,
  entityName = null,
  metadata   = {},
}) {
  return {
    id:         `rt_${Date.now()}_${(++_seq).toString(36)}`,
    type,
    ts:         Date.now(),
    route,
    module,
    entityType,
    entityId,
    entityName,
    metadata,
  };
}
